const isKorean = (text) => /([\uAC00-\uD7AF\u3130-\u318F])+/gi.test(text);

export { isKorean };
//# sourceMappingURL=i18n.mjs.map
